import { get, getWithParams, post, put } from "../../utils/fetchAPI";

export const mergeTemplateToPrescription = async (payload, visitId) => {
  const res = await post(`/visit/add-template/${visitId}`, payload);
  return res;
};


export const prescriptionAddSubDocument = async (objKey, payload, visitId) => {
  const res = await put(`/visit/add-sub-document/${visitId}`, { [objKey]: payload });
  return res;
};


export const prescriptionAddSubDocumentArray = async (objKey, payload, visitId) => {
  const res = await put(`/visit/add-sub-documents/${visitId}`, { data: payload, documentKey: objKey });
  return res;
};

export const prescriptionUpdateSubDocument = async (objKey, payload, visitId) => {
  payload = { ...payload, key: objKey }
  const res = await put(`/visit/update-sub-document/${visitId}`, payload);
  return res;
};

export const prescriptionRemoveSubDocument = async (objKey, payload, visitId) => {
  const res = await put(`/visit/remove-sub-document/${visitId}`, { [objKey]: payload });
  return res;
};

export const getPreviousVisitPhysicalExams = async (visitId) => {
  const res = await get(`/visit/previous-physical-exam/${visitId}`);
  return res;
};

export const addPastMedication = async (payload, visitId) => {
  const res = await put(`/visit/add-past-medication/${visitId}`, payload);
  return res;
};

export const removePastMedication = async (id, visitId) => {
  const res = await put(`/visit/remove-past-medication/${visitId}`, { _id: id });
  return res;
};

export const updatePastMedication = async (id, note, visitId) => {
  const res = await put(`/visit/update-past-medication/${visitId}`, { _id: id, note });
  return res;
};

// Other brands of a prescribed medicine: same generic, same type, same strength
// (so only the brand name changes). -> { total, items: [master medicines] }
// params: { generic, type, power, medicineId, search, manufacturerName, medicinePriority }
export const getMedicineAlternatives = async (params) => {
  const res = await getWithParams(`/medicine/alternatives`, params);
  return res;
};
